import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Toggle } from './settingsPrimitives';
import { setSiteIconsEnabled, siteIconsEnabled } from '../services/siteIcons';

/** Settings → Extensions → Vault → "Show website icons" (card 6.2). */
export default function VaultSiteIconsRow() {
  const { t } = useTranslation();
  const [on, setOn] = useState(siteIconsEnabled);

  return (
    <Row
      label={t('vault.iconsShow', 'Show website icons')}
      desc={t(
        'vault.iconsShowDesc',
        'Icons are looked up by site name only (google.com), never a full address, a username or your account. Off: Apiboo makes no icon requests at all.'
      )}
    >
      <Toggle
        value={on}
        onChange={(next) => {
          setOn(next);
          setSiteIconsEnabled(next);
        }}
      />
    </Row>
  );
}
